// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"89ea55c5","453":"e2d8c180","455":"651a02b4","977":"da5c7fec"}[chunkId] + ".chunk.js";
};